import { AppContextType } from "../../../../context/AppContext"
import useAppContext from "../../../../hooks/useAppContext"
import { DateType } from "../../../../static/types/commonTypes/dateType"
import DateComponent from "../../../commonComponents/DateComponent"

const ChangeDuration = () => {

    const {
        durationChangeEffectiveDate,
        setDurationChangeEffectiveDate,
        setDurationChangeEffectiveDateValidity,
        durationChangeEffectiveDateChecked,

        durationChangeDate,
        setDurationChangeDate,
        setDurationChangeDateValidity,
        durationChangeDateChecked,

        durationChange,
        setDurationChange,

    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setDurationChangeDate ({...durationChangeDate, ...data});
    const updateEffectiveDate = (data: Partial<DateType>) => setDurationChangeEffectiveDate ({...durationChangeEffectiveDate, ...data});

    return (
        <div>
            <div className = 'col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor = "denomination" className = "col-sm-2 col-form-label mb-0"> Proroger </label>
                <select
                    className = 'form-select w-75'
                    id = "denomination"
                    onChange = {( e ) => setDurationChange( Number( e.target.value ))}
                    value = { durationChange }
                >
                    <option value = { 0 }> Aucune modification </option>
                    <option value = { 1 }> Prorogation </option>
                </select>
            </div>

            {
                durationChange === 1 &&
                    <div className = "mt-3 col-sm-7">
                        <DateComponent
                            id="durationChangeEffectiveDate"
                            date = { durationChangeEffectiveDate }
                            draftFieldName = "durationChangeEffectiveDate"
                            changeDate = { updateEffectiveDate }
                            dateLabel = "Date d'effet"
                            checked = { durationChangeEffectiveDateChecked }
                            onValidationChange = {( isValid: boolean ) => setDurationChangeEffectiveDateValidity( isValid )}
                            required = { false }
                        />

                        <DateComponent
                            id="durationChangeDate"
                            date = { durationChangeDate }
                            draftFieldName = "durationChangeDate"
                            changeDate = { updateDate }
                            dateLabel = "Date"
                            checked = { durationChangeDateChecked }
                            onValidationChange = {( isValid: boolean ) => setDurationChangeDateValidity( isValid )}
                            required = { false }
                        />

                    </div>
            }                
        </div>
    )
}

export default ChangeDuration 